import { useEffect, useRef } from 'react';

// Remonte en haut de la page quand `value` change (ex. étape d'un onboarding).
// Le contenu de l'admin défile dans .ad-main (ordinateur), sinon la fenêtre (mobile).
export function useScrollTopOnChange<T extends HTMLElement>(value: unknown) {
  const ref = useRef<T>(null);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    ref.current?.closest('.ad-main')?.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [value]);
  return ref;
}
